import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  vps: null,
  monitoring: null,

  prize: null,

  sendStatus: '',
};

export const discountSlice = createSlice({
  name: 'discount',
  initialState,
  reducers: {
    setDiscountsVps: (state, action) => {
      state.vps = action.payload;
    },
    setDiscountsMonitoring: (state, action) => {
      state.monitoring = action.payload;
    },

    setDiscountPrize: (state, action) => {
      state.prize = action.payload;
    },

    setSendDiscountStatus: (state, action) => {
      state.sendStatus = action.payload;
    },

    resetDiscount: () => initialState,
  },
});

export const {
  setDiscountsVps,
  setDiscountsMonitoring,

  setDiscountPrize,

  setSendDiscountStatus,

  resetDiscount,
} = discountSlice.actions;

export default discountSlice.reducer;
